import { FC } from 'react';
import styled from 'styled-components';

import { HelpTooltip } from '../../../../shared/common/HelpTooltip';

import { LocalContentRadioButtonGroup } from './LocalContentRadioButtonGroup';
import { RESTRICTION_LEVEL_LIMITED, RESTRICTION_LEVEL_WORLD } from './SetLiveOnLibXChangePopup';
import { useTranslation } from 'react-i18next';

const DistributionTooltip = styled(HelpTooltip)`
    line-height: 1;
    margin-left: 5px;
`;

interface Props {
    onChangeSharingRestriction: (restrictionLevel: string) => void;
    selectedRestriction?: string;
}

export const LimitedSharingOption: FC<Props> = props => {
    const { t } = useTranslation();
    return (
        <>
            <span
                className="cold-grey"
                style={{ marginBottom: '5px', marginTop: '15px', display: 'flex', lineHeight: 1 }}
            >
                {t('yourLocalContent.yourTitles.distribution')}
                <DistributionTooltip text={t('yourLocalContent.yourTitles.warnings.distributionChanged')} />
            </span>

            <LocalContentRadioButtonGroup
                onRadioChanged={props.onChangeSharingRestriction}
                selectedOption={props.selectedRestriction}
                options={[
                    { key: RESTRICTION_LEVEL_WORLD, value: t('yourLocalContent.yourTitles.worldwide') },
                    { key: RESTRICTION_LEVEL_LIMITED, value: t('yourLocalContent.yourTitles.limited') }
                ]}
            />
        </>
    );
};
